var React = require('react');

function FlagSo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 423.725H8.828A8.829 8.829 0 010 414.897V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828v317.793a8.83 8.83 0 01-8.829 8.828z","fill":"#82afff","key":0}),React.createElement("path",{"d":"M253.466 193.443l-14.81 44.409-46.813.363c-2.567.02-3.63 3.295-1.566 4.82l37.658 27.809-14.121 44.632c-.775 2.447 2.012 4.471 4.099 2.978L256 291.234l38.086 27.222c2.088 1.492 4.874-.532 4.099-2.978l-14.121-44.633 37.658-27.809c2.065-1.525 1.001-4.8-1.566-4.82l-46.813-.363-14.81-44.409c-.812-2.435-4.254-2.435-5.067-.001z","fill":"#f5f5f5","key":1})]);
}

FlagSo.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagSo;

FlagSo.default = FlagSo;
